<template>
    <div id="Documento_div" class="w-100 px-0 py-0">
        <div id="TituloEdicionDocumento_div">
            <h4>Edición de Estatus del Documento</h4>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area">
                    <div id="Detalle_div">
                        <div class="row">
                            <div class="form-group col-8" id="Area_div"> 
                                <label>Área</label>                                  
                                <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly/>
                            </div>
                            <div class="form-group col-4" id="Materia_div"> 
                                <label>Materia</label>
                                <div v-if="Documento.Materia != null">                                 
                                    <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
                                </div>
                                <div v-else>
                                    <input type="text" class="form-control" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-4" id="TipoDocumento_div"> 
                                <label>Tipo de Documento</label>                                  
                                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
                            </div>
                            <div class="form-group col-4" id="Anio_div"> 
                                <label>Año</label>
                                <input type="text" class="form-control " v-model="Documento.Año" readonly/>
                            </div>
                            <div class="form-group col-4" id="Consecutivo_div"> 
                                <label>Consecutivo</label>                                  
                                <input type="text"  class="form-control" v-model="Documento.Consecutivo" readonly/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-4" id="CodigoBarras_div"> 
                                <label>Codigo de Barras</label>                                  
                                <input type="text"  class="form-control" v-model="Documento.CodigodeBarras" readonly/>
                            </div>
                            <div class="form-group col-4" id="FechaRegistro_div">
                                <label>Fecha de Registro</label>
                                <input type="text" class="form-control" v-model="Documento.Fecha_Registro" readonly/>
                            </div>
                            <div class="form-group col-4" id="EstatusDocumento_div">
                                <label>Estatus del Documento</label>
                                <Estatus
                                    v-on:valorParaElPadre="cambioDeEstatus" 
                                    :prefijo ="enumeraciones.etiquetasDeHTML.Select"
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="'Busqueda_TipoEstatus'" 
                                    :valorDefinido="parametros_TipoInventario.tipoEstatusInventarioDocumentoId = parametros_TipoInventario.tipoEstatusInventarioDocumentoId != undefined && parametros_TipoInventario.tipoEstatusInventarioDocumentoId !=null ? parametros_TipoInventario.tipoEstatusInventarioDocumentoId : -1"
                                    :parametros ="parametros_TipoInventario.parametros"
                                    :key="parametros_TipoInventario.key = parametros_TipoInventario.tipoEstatusInventarioDocumentoId != undefined && parametros_TipoInventario.tipoEstatusInventarioDocumentoId != null ? parametros_TipoInventario.tipoEstatusInventarioDocumentoId : ''">
                                </Estatus>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-4" id="botonAceptar_div">
                                <button class="btn btn-secondary"  @click='GuardaDocumento()'>Aceptar</button>
                            </div>
                            <div class="form-group col-4" id="botonCancelar_div">
                                <button class="btn btn-secondary"  @click='VolverInventario(Documento.CodigodeBarras)'>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    components: {
        Estatus : catalogos.ArchivoJudicial.C003TipoEstatusDocumento
    },
    props: {
        parametrosEstablecidos: {
            default: () => ({
                TipoEstatusInventarioDocumentoId: null
            })
        }, 
        barraCodeEdit: {
            type: String,
            default: ""
        }
    },
    data(){
        return{
            enumeraciones,
            Documento: {
                InventarioDocumentoId: "",
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
                CodigodeBarras: "",
                Fecha_Registro: null,
                Estatus: {}
                },
            parametros_TipoInventario: {
                key: "",
                tipoEstatusInventarioDocumentoId: -1,
                parametros: {}
                }
        }
    },
    methods: {
        cambioDeEstatus(datos){
            this.parametros_TipoInventario.tipoEstatusInventarioDocumentoId = parseInt(datos.target.value);
        },
        ObtenerDocumento(dato){
            
            var peticion = {
                "AreaId": -1,
                "TipoDocumentoId" : -1,
                "Anio" : null,
                "Consecutivo": null,
                "CodigoBarras": dato,
            };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumento, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.Documento=null;
                }
                else
                {
                    this.Documento.InventarioDocumentoId = respuesta.data.GetDocumento.InventarioDocumentoId;
                    this.Documento.Area = respuesta.data.GetDocumento.Area;
                    this.Documento.Materia = respuesta.data.GetDocumento.Materia;
                    this.Documento.TipoDocumento = respuesta.data.GetDocumento.TipoDocumento;
                    this.Documento.Año = respuesta.data.GetDocumento.Anio;
                    this.Documento.Consecutivo = respuesta.data.GetDocumento.Consecutivo;
                    this.Documento.CodigodeBarras = respuesta.data.GetDocumento.CodigoBarras;
                    this.Documento.Fecha_Registro = moment(respuesta.data.GetDocumento.FechaRegistro).format('DD-MM-YYYY HH:mm');
                    this.parametros_TipoInventario.tipoEstatusInventarioDocumentoId = respuesta.data.GetDocumento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId;
                   
                }
                comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                this.Documento = null;
            })
        },
        GuardaDocumento: function(){
            var peticion = {
                "InventarioDocumentos": {
                    "InventarioDocumentoId": this.Documento.InventarioDocumentoId,
                    "TipoEstatusInventario": {"TipoEstatusInventarioDocumentoId": this.parametros_TipoInventario.tipoEstatusInventarioDocumentoId},
                }
            };
            
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.GuardaDocumento, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else{
                    comun.mensajeDeAlerta("Se Modifico satisfactoriamente el Estatus del Documento");
                    comun.SeEstaCargandoInformacion(false);
                    this.VolverInventario(this.barraCodeEdit);
                    }
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        },
        VolverInventario(codigo){
            
            router.push ({name: 'Inventario', params: {barraCode: codigo}});
        }
    },
    mounted(){
        console.log(this.barraCodeEdit);
        if (this.barraCodeEdit != "" && this.barraCodeEdit != undefined)
        {
            this.ObtenerDocumento(this.barraCodeEdit);
        }
    }
}
</script>

<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }
input[type="text"]:read-only:focus {
      color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/EditaDocumento.vue